'use client';

import { useContext, useEffect, useRef } from 'react';
import { usePathname, useSearchParams } from 'next/navigation';
import { AppContext } from '../context/AppContext';
import { trackCustomerIoPage } from '../lib/customerio';

export default function CustomerIoPageTracker() {
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const lastTrackedUrlRef = useRef(null);
  const { user } = useContext(AppContext);

  useEffect(() => {
    if (!user) return;
    if (typeof window === 'undefined') return;

    const query = searchParams?.toString();
    const fullUrl = `${window.location.origin}${pathname || '/'}${
      query ? `?${query}` : ''
    }`;

    if (lastTrackedUrlRef.current === fullUrl) return;

    lastTrackedUrlRef.current = fullUrl;
    void trackCustomerIoPage(fullUrl);
  }, [pathname, searchParams, user]);

  return null;
}
